import React from 'react';
import { createRoot } from 'react-dom/client';
import { initProductCarousels } from './productCarousel';
import './product-carousel.scss';
import '../../../utils/productItem/product-meta.scss';
import { CarouselContent } from './CarouselContent';

const {
  pageType,
  advancedCommerce: { productRecommendations },
} = window.inlineGlobalConfig || {};

if (pageType === 'homepage' && productRecommendations) {
  const wrappers = document.querySelectorAll('.product-carousel__wrapper');

  if (wrappers.length > 0) {
    wrappers.forEach(wrapper => {
      wrapper.innerHTML = '';

      const root = createRoot(wrapper);

      root.render(<CarouselContent />);
    });
  } else {
    console.warn('No .product-carousel__wrapper elements found on homepage');
  }
}

initProductCarousels();
